import { mobileLargeMin, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';

const is12n = css`
  &:nth-child(12n + 1) {
    grid-column: 1;
    grid-row: span 1;
  }

  &:nth-child(12n + 2) {
    grid-column: 1;
    grid-row: span 1;
  }

  &:nth-child(12n + 3) {
    grid-column: 2 / span 2;
    grid-row: span 2;
  }

  &:nth-child(12n + 4) {
    grid-column: 1 / span 2;
  }

  &:nth-child(12n + 5) {
    grid-column: span 1;
    grid-row: span 1;
  }

  &:nth-child(12n + 6) {
    grid-column: 1 / span 2;
    grid-row: span 2;
  }

  &:nth-child(12n + 7) {
    grid-column: span 1;
  }

  &:nth-child(12n + 8) {
    grid-row: span 1;
  }

  &:nth-child(12n + 9) {
    grid-column: span 1;
  }

  &:nth-child(12n + 10) {
    grid-column: span 2;
  }

  &:nth-child(12n + 11) {
    grid-column: span 2;
    grid-row: span 1;
  }

  &:nth-child(12n + 12) {
    grid-column: span 1;
    grid-row: span 1;
  }
`;

const lastFull = css`
  ${is12n}

  &:last-child {
    grid-column: span 3;
    grid-row: span 2;
  }
`;

const last2Full = css`
  ${is12n}

  &:nth-last-child(2) {
    grid-column: span 2;
    grid-row: span 1;
  }

  &:last-child {
    grid-column: span 1;
    grid-row: span 1;
  }
`;

const last2FullAlt = css`
  ${is12n}

  &:nth-last-child(2) {
    grid-column: span 1;
    grid-row: span 1;
  }

  &:last-child {
    grid-column: span 2;
  }
`;

const last3 = css`
  ${is12n}

  &:nth-last-child(3) {
    grid-column: 1;
    grid-row: auto;
  }

  &:nth-last-child(2) {
    grid-column: 1;
    grid-row: auto;
  }

  &:last-child {
    grid-column: 2 / span 2;
    grid-row: span 2;
  }
`;

export const ImageGrid = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
`;

export const GalleryImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ExpandIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.white};
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1;
  opacity: 1;
  transition: opacity linear 300ms;

  &:hover {
    opacity: 0.5;
  }
`;

export const ImageRow = styled.div`
  display: flex;
  gap: 10px;

  @media (${mobileXXLargeMax}) {
    gap: 6px;
  }
`;

export const GalleryImgWrapper = styled.div<{ total: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  /* @media (${mobileLargeMin}) {
    ${({ total }) => {
    if (total === 11 || (total > 12 && total % 12 === 11)) return last3;
    if (total === 9 || (total > 12 && total % 12 === 9)) return lastFull;
    if (total === 7 || (total > 12 && total % 12 === 7)) return last2FullAlt;
    if (total === 6 || (total > 12 && total % 12 === 6)) return lastFull;
    if (total === 4 || (total > 12 && total % 12 === 4)) return lastFull;
    if (total === 2) return last2Full;
    if (total > 12 && total % 12 === 2) return last2FullAlt;
    if (total === 1 || (total > 12 && total % 12 === 1)) return lastFull;
    return is12n;
  }}
  } */

  ${GalleryImg} {
    scale: 1;
    transition: scale linear 300ms;
  }

  &::after {
    content: '';
    position: absolute;
    background-color: transparent;
    transition: background-color linear 300ms;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

  &:hover {
    ${GalleryImg} {
      scale: 1.1;
    }
    ${ExpandIcon} {
      opacity: 0.5;
    }
    &::after {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
`;
